import { Camera, Video, Film, Sparkles } from 'lucide-react';

export const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export const LOADING_MESSAGES = [
  "Iris is adjusting the whites. No, the other whites. No, the dress whites.",
  "Brb, Iris is arguing with herself about whether this is moody enough...",
  "Putting more thought into this than most DJs put into their playlists...",
  "Creating something that'll make your photographer friends text you 'who designed your site??'",
  "Designing a site worthy of that one golden hour shot you'll never shut up about. (Rightfully so.)",
  "Color grading your website the way you color grade your edits. Perfectly.",
  "Picking typography like you pick lenses. Thoughtfully and with strong opinions.",
  "Adding the kind of details only a creative would notice. And then obsess over.",
  "Making your website look as good as your work does at 2pm in October light.",
  "Crafting an inquiry page so good, you'll actually want people to fill it out.",
  "Creating the website your pricing deserves.",
  "Building a site so stunning, even the planners will send you referrals.",
  "Designing something that says 'luxury' without literally writing 'luxury' on everything.",
  "Making your about page sound like you, not like every other photographer's about page.",
  "We're obsessing over every pixel so you don't have to. Okay, you still will. But that's your thing.",
];

export const VIBES = [
  { key: 'romantic', label: 'Romantic & Warm', desc: 'Golden hour, soft light, intimate', colors: ['#FDF8F3', '#C4A095', '#2D2420'] },
  { key: 'cinematic', label: 'Cinematic & Dark', desc: 'Film noir, dramatic, luxurious', colors: ['#0F0E0D', '#C9A84C', '#E8E6E3'] },
  { key: 'editorial', label: 'Editorial & Clean', desc: 'Magazine, white space, bold type', colors: ['#FAFAFA', '#B89B55', '#1A1A1A'] },
  { key: 'earthy', label: 'Earthy & Natural', desc: 'Garden, sage, organic textures', colors: ['#F5F0EB', '#7A8B6F', '#2C2622'] },
  { key: 'moody', label: 'Moody & Bold', desc: 'Deep tones, candlelit, passionate', colors: ['#1A1618', '#D4A574', '#F0ECE8'] },
  { key: 'minimal', label: 'Minimal & Modern', desc: 'Clean lines, gallery, architectural', colors: ['#f5f2ee', '#2A2A2A', '#1A1A1A'] },
  { key: 'whimsical', label: 'Whimsical & Playful', desc: 'Fun, dreamy, rose pink', colors: ['#FFF5F5', '#E8A0BF', '#3D2B2B'] },
  { key: 'documentary', label: 'Documentary & Raw', desc: 'Honest, unposed, real moments', colors: ['#F2F0ED', '#8B7355', '#1C1C1C'] },
  { key: 'classic', label: 'Classic & Timeless', desc: 'Elegant, refined, never dated', colors: ['#FAF9F7', '#8B6F4E', '#1A1A2E'] },
  { key: 'bohemian', label: 'Bohemian & Free', desc: 'Boho, terracotta, adventurous', colors: ['#F8F3ED', '#C17A50', '#2E2520'] },
  { key: 'luxe', label: 'Luxe & Opulent', desc: 'Black tie, gold, high-end', colors: ['#0D0D0D', '#C9A96E', '#F0EDE8'] },
  { key: 'film', label: 'Film & Analog', desc: 'Vintage tones, grain, warmth', colors: ['#F0ECE4', '#9B8B6B', '#2A2622'] },
];

export const TYPES = [
  { key: 'photographer', label: 'Photographer', icon: Camera },
  { key: 'videographer', label: 'Videographer', icon: Video },
  { key: 'content_creator', label: 'Content Creator', icon: Sparkles },
];

export const VIDEOS = [
  { id: 'dQw4w9WgXcQ', title: 'Never Gonna Give You Up', year: '2009' },
  { id: 'nGeKSiCQkPw', title: 'Ultimate Dog Tease (Maple Bacon)', year: '2011' },
  { id: 'OQSNhk5ICTI', title: 'Double Rainbow', year: '2010' },
  { id: 'J---aiyznGQ', title: 'Keyboard Cat', year: '2007' },
  { id: '9bZkp7q19f0', title: 'Gangnam Style', year: '2012' },
  { id: 'dMH0bHeiRNg', title: 'Evolution of Dance', year: '2006' },
  { id: 'jNQXAC9IVRw', title: 'Me at the Zoo (1st YT video)', year: '2005' },
  { id: 'iRZ2Sh5-XuM', title: 'Sneezing Baby Panda', year: '2006' },
  { id: 'Awf45u6zrP0', title: 'Evolution of Dance 2', year: '2009' },
  { id: 'RP4abiHdQpc', title: 'David After Dentist', year: '2009' },
  { id: 'KmtzQCSh6xk', title: 'Charlie the Unicorn', year: '2008' },
  { id: 'dMH0bHeiRNg', title: 'Judson Laipply Dance', year: '2006' },
  { id: 'hY7m5jjJ9mM', title: 'Surprised Kitty', year: '2009' },
];
